import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import { MedicalSterilizationModel } from '../../../api/entity/medicalSterilization.model';

@Injectable({
  providedIn: 'root'
})
export class MedicalSterilizationRepository extends AbstractRepositoryV2<MedicalSterilizationModel> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
    super('MedicalSterilization', serviceElementsFactory, injector);
  }
}

